import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import type { SummaryStats } from "./types";

interface SummaryCardsProps {
  summary: SummaryStats | null;
  formatNumber: (value?: number | string) => string;
  formatPercent: (value?: number | string) => string;
}

const SummaryCards: React.FC<SummaryCardsProps> = ({
  summary,
  formatNumber,
  formatPercent,
}) => {
  if (!summary) return null;

  const cards = [
    { label: "Total orders", value: formatNumber(summary.total_orders) },
    { label: "Total leads", value: formatNumber(summary.total_leads) },
    { label: "Total daily cap", value: formatNumber(summary.total_daily_cap) },
    { label: "Utilization", value: formatPercent(summary.utilization_pct) },
    { label: "Avg leads / day", value: formatNumber(summary.avg_leads_per_day) },
    { label: "Unique funnels", value: formatNumber(summary.total_funnels) },
    { label: "Unique brokers", value: formatNumber(summary.total_brokers) },
    { label: "Unique offices", value: formatNumber(summary.total_offices) },
    { label: "Buyer teams", value: formatNumber(summary.total_buyer_teams) },
    { label: "Affiliates", value: formatNumber(summary.total_affiliates) },
  ];

  return (
    <>
      <Row className="g-4 mb-2">
        {cards.map((item) => (
          <Col key={item.label} xl={3} md={6}>
            <Card className="m-0">
              <CardBody>
                <div className="text-muted">{item.label}</div>
                <div className="h4 mb-0">{item.value}</div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
      <Row className="mb-4">
        <Col xl={12}>
          <div className="text-muted small">
            Utilization = Total leads / Total daily cap. Counts are based on traffic_order_capas within the selected range.
          </div>
        </Col>
      </Row>
    </>
  );
};

export default SummaryCards;
